import React from "react";
import styles from "../modules/AboutUs.module.css";

const AboutUs = () => {
  return (
    <div className={styles.aboutContainer}>
      {/* LOGO SECTION */}
      <div className={styles.logoSection}>
        <img src="/logo.png" alt="Shonix Solutions" className={styles.logo} />
      </div>

      {/* DIFFERENCE SECTION */}
      <section className={styles.difference}>
        <h2>What Makes Us Different</h2>

        <div className={styles.cards}>
          <div className={styles.card}>
            <img src="/logo-14.png" alt="Industry Cards" className={styles.icon} />
            <h3>100% Custom-Built Systems</h3>
            <p style={{ marginBottom: "1rem" , marginTop: "11%" }}>
              We don’t believe in one-size-fits-all. Every software, website, and tool
              we create is uniquely built for the client’s process, design preference,
              and goals.
            </p>
            <p className={styles.note}>Your system reflects you — from dashboard to database.</p>
          </div>

          <div className={styles.card}>
            <img src="/logo-15.png" alt="Industry Cards" className={styles.icon} />
            <h3>Registered & Trusted (MSME Certified)</h3>
            <p>
              <strong>Shonix Solutions</strong> is a registered MSME-certified company,
              ensuring credibility, accountability, and full compliance with government
              business standards.
            </p>
            <p className={styles.note}>
              We officially handle all business requests, project contracts, and
              software requirements with complete transparency.
            </p>
          </div>

          <div className={styles.card}>
            <img src="/logo-16.png" alt="Industry Cards" className={styles.icon} />
            <h3>Professional & Skilled Team</h3>
            <p style={{ marginBottom: "14%" , marginTop: "11%" }}>
              Our team consists of experienced developers, UI/UX designers, analysts,
              and creative professionals.
            </p>
            <p className={styles.note}>
              Every project is managed with precision, professionalism, and care —
              ensuring top-quality results and on-time delivery.
            </p>
          </div>
        </div>
      </section>

      {/* ABOUT SECTION */}
      <section className={styles.aboutIntro}>
        <h2>Our Purpose</h2>
        <p>
          At <strong>Shonix Solutions</strong>, we believe that every business deserves
          software that adapts to them — not the other way around.
        </p>
        <p>
          We’re a professional technology company specializing in customized digital
          solutions designed for real-world needs across education, healthcare,
          hospitality, retail, and small business sectors.
        </p>
        <p>
          We don’t sell pre-made templates. <br />
          <strong>We build your system your way — tailored, scalable, and efficient.</strong>
        </p>
      </section>

      {/* MISSION QUOTE */}
      <section className={styles.quote}>
        <p>
          “To deliver fully customized digital solutions that empower our clients
          to achieve their goals.”
        </p>
      </section>
      {/* FOOTER */}
      <footer className={styles.footer}>
        <p>© 2024 Shonix Solutions. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default AboutUs;
